module.exports = __webpack_public_path__ + "media/src/img/payment/visa-logo-icon-6e72c866da37a2bcabb516ce8a7cc33c.svg";